import React from 'react';
import { withRouter } from 'react-router';
import { SEGMENT_EVENTS, trackUserInteraction } from '../../../utils/tracking';

const TRACKING_PREFIX = 'global_search';

const getPathInfo = (router) => {
  if (!router) return;
  const { pathname, search } = router.getCurrentLocation();
  return {
    currentPage: `${pathname}${search}`,
    currentPath: pathname,
  };
};

const WithTracking = (ChildComponent) => ({ router, ...props }) => {
  const getSharedTrackingParams = (name) => {
    return {
      ...getPathInfo(router),
      source: TRACKING_PREFIX,
      shortName: name,
      name: `${TRACKING_PREFIX}_${name}`,
    };
  };

  const trackTagSearchClicked = (params = {}) => {
    trackUserInteraction(SEGMENT_EVENTS.BUTTON_CLICKED, {
      ...getSharedTrackingParams('tag_search_result'),
      ...params,
    });
  };

  const trackEventSearchClicked = (params = {}) => {
    trackUserInteraction(SEGMENT_EVENTS.BUTTON_CLICKED, {
      ...getSharedTrackingParams('event_search_link'),
      ...params,
    });
  };

  const trackLocationSearchClicked = (params = {}) => {
    trackUserInteraction(SEGMENT_EVENTS.BUTTON_CLICKED, {
      ...getSharedTrackingParams('location_search_link'),
      ...params,
    });
  };

  const trackNearMeSearchClicked = (params = {}) => {
    trackUserInteraction(SEGMENT_EVENTS.BUTTON_CLICKED, {
      ...getSharedTrackingParams('near_me_search_link'),
      ...params,
    });
  };

  const trackShowAllClicked = (params = {}) => {
    trackUserInteraction(SEGMENT_EVENTS.BUTTON_CLICKED, {
      ...getSharedTrackingParams('event_see_all_results'),
      ...params,
    });
  };

  const trackInputEntered = (eventName, params = {}) => {
    trackUserInteraction(SEGMENT_EVENTS.INPUT_ENTERED, {
      ...getSharedTrackingParams(eventName),
      ...params,
    });
  };

  const trackPanelOpened = (eventName, params = {}) => {
    trackUserInteraction(SEGMENT_EVENTS.PANEL_OPENED, {
      ...getSharedTrackingParams(eventName),
      ...params,
    });
  };

  const trackPanelClosed = (eventName, params = {}) => {
    trackUserInteraction(SEGMENT_EVENTS.PANEL_CLOSED, {
      ...getSharedTrackingParams(eventName),
      ...params,
    });
  };

  const tracking = {
    trackTagSearchClicked,
    trackEventSearchClicked,
    trackLocationSearchClicked,
    trackNearMeSearchClicked,
    trackShowAllClicked,
    trackInputEntered,
    trackPanelOpened,
    trackPanelClosed,
  };

  return <ChildComponent {...props} injected={tracking} />;
};

export default (childComponent) => withRouter(WithTracking(childComponent));
